import React from 'react';
import { contactInfo } from '../data/mock';
import { locationList } from '../data/locations';
import { Dog, Mail, MapPin, Clock, Facebook, Instagram, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Dog Boarding Services', href: '#services' },
    { name: 'About Us', href: '#about' },
    { name: 'Reviews', href: '#testimonials' },
    { name: 'FAQ', href: '#faq' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-stone-900 text-stone-300" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="/" className="flex items-center gap-2 mb-4" aria-label="Dog Boarding Baltimore Home">
              <div className="w-10 h-10 bg-amber-500 rounded-xl flex items-center justify-center">
                <Dog className="w-6 h-6 text-white" aria-hidden="true" />
              </div>
              <div>
                <span className="font-bold text-lg text-white">Dog Boarding</span>
                <span className="block text-xs text-amber-500 font-medium -mt-1">Baltimore</span>
              </div>
            </a>
            <p className="text-stone-400 leading-relaxed mb-6">
              Baltimore's #1 trusted dog boarding service. Locally owned, background-checked staff, loved by your neighbors for 5+ years.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-stone-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" aria-hidden="true" />
              </a>
              <a href="#" className="w-10 h-10 bg-stone-800 hover:bg-amber-500 rounded-lg flex items-center justify-center transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-stone-400 hover:text-amber-500 transition-colors"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas - Now with links! */}
          <div>
            <h4 className="text-white font-semibold mb-4">Areas We Serve</h4>
            <ul className="space-y-2">
              {locationList.map((location) => (
                <li key={location.slug}>
                  <a 
                    href={`/${location.slug}`}
                    className="text-stone-400 hover:text-amber-500 transition-colors text-sm"
                  >
                    Dog Boarding {location.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li>
                <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-3 text-stone-400 hover:text-amber-500 transition-colors">
                  <Mail className="w-4 h-4" aria-hidden="true" />
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-stone-400">
                <MapPin className="w-4 h-4" aria-hidden="true" />
                {contactInfo.address}
              </li>
              <li className="flex items-center gap-3 text-stone-400">
                <Clock className="w-4 h-4" aria-hidden="true" />
                {contactInfo.hours}
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-stone-500 text-sm">
              © {currentYear} Dog Boarding Baltimore. All rights reserved. | Baltimore's Trusted Pet Care
            </p>
            <p className="text-stone-500 text-sm flex items-center gap-1">
              Made with <Heart className="w-4 h-4 text-red-500 fill-red-500" aria-hidden="true" /> in Baltimore, MD
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
